import { useWSInfiniteQuery, WSInfiniteQueryConfig } from "@ws-react-query";
import { listInternalAccountTransactions } from "../../../services/api/banking/internalAccounts";
import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSServiceError } from "../../../utils/serviceHelper";

export const QUERY_LIST_INTERNAL_ACCOUNT_TRANSACTIONS =
  "QUERY_LIST_INTERNAL_ACCOUNT_TRANSACTIONS";

export const useQueryListInternalAccountTransactions = (
  internalAccountId: Parameters<typeof listInternalAccountTransactions>[0],
  query?: bankingApiSpec.operations["listInternalAccountTransactions"]["parameters"]["query"],
  config?: WSInfiniteQueryConfig<
    Awaited<ReturnType<typeof listInternalAccountTransactions>>,
    WSServiceError
  >
) =>
  useWSInfiniteQuery(
    [QUERY_LIST_INTERNAL_ACCOUNT_TRANSACTIONS, internalAccountId, query],
    () => listInternalAccountTransactions(internalAccountId, query),
    {
      getNextPageParam: () => false,
      ...config
    }
  );
